<template>
    <div class="footer animated fadeInUp">
      <div class="footer-top">
        <div class="container">

      <div class="copyright footer">
        <div class="container">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" class="text-center">
              <p>Copyright &copy; 2022 德清 er 寻觅你想要的！
                <a target="_blank" href="http://beian.miit.gov.cn/" rel="nofollow" style="margin-left:5px;">{{website.copyright}}</a>
              </p>
              <p>本网站由 <a style="color: #66b1ff" target="_blank" href="https://www.upyun.com/?utm_source=lianmeng&utm_medium=referral">
                又拍云</a> 提供CDN加速/云存储服务
              </p>
            </el-col>
          </el-row>
        </div>
      </div>
      </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: 'blogFooter',
  props: {
    blogger: {
      type: Object,
      default: () => ({})
    },
    blogLinks: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  mounted() {
  },
  methods: {
    clickAuthor() {
      this.$router.push({ path: this.website.authorPage })
    }
  },
  computed: {
    ...mapGetters(["website"])
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/blog/blog-common.scss';
.footer {
    background-color: #444444 !important;
  .container {
      width: 90%;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
  }
  .footer-top {
      background: #232328;
      padding: 25px 0;
      background-color: #444444 !important;
  }
  .single-widget {
      margin-top: 30px;
      h2 {
          color: #fff;
          font-size: 18px;
          margin-bottom: 20px;
          text-transform: uppercase;
      }
  }
  .footer-logo {
      h2 {
          font-family: BarbaraHand;
          font-size: 40px !important;
          margin-bottom: 20px;
      }
  }
  .about {
      p {
          color: #eee;
      }
  }
  .button {
      .btn {
          margin-top: 20px;
          &:hover {
              border-color: #fff;
          }
      }
  }
  .contact {
      ul {
          li {
              color: #eee;
              position: relative;
              padding-left: 40px;
              font-family: Roboto,sans-serif;
              margin-bottom: 10px;
              list-style: none;
              &:last-child {
                  margin: 0;
              }
              i {
                  position: absolute;
                  top: 50%;
                  width: 30px;
                  height: 30px;
                  text-align: center;
                  line-height: 30px;
                  left: 0;
                  margin-top: -15px;
                  font-size: 16px;
              }
              a {
                  color: #fff;
              }
          }
      }
  }
  .s-code {
    img {
      width: 25%;
    }
  }
  .social-icon {
      li {
          float: left;
          width: 50%;
          margin-bottom: 10px;
          &:last-child {
              margin: 0;
          }
          a {
              color: #eee;
              &:hover {
                  color: #82b440;
              }
              i {
                  margin-right: 10px;
                  width: 20px;
                  font-size: 16px;
              }
          }
      }
  }
  .copyright {
      padding: 12px 0;
      background: #1d1d21;
      p {
          color: #bbb;
          font-size: 14px;
      }
  }
}
.wechatimg {
    width: 121px;
    height: 121px;
}
</style>
